import { InjectionToken, Type } from '@angular/core';

export interface WidgetComponent<T = any> {
  json: T;
}

export type WidgetRegistry = Record<string, Type<WidgetComponent>>;

export const WIDGET_REGISTRY = new InjectionToken<WidgetRegistry>('WIDGET_REGISTRY');